import { Typography } from '@mui/material';
import { ScreeningResultsOption, ScreeningResultsTypes } from './ScreeningResultsTypes';

export const staticSmbScreeningResultsOptions: ScreeningResultsOption[] = [
  {
    id: 'low',
    text: 'Low Coverage',
    subText: '2 months Rent Coverage, 1 month Deposit Coverage',
    value: ScreeningResultsTypes.Approved,
  },
  {
    id: 'medium',
    text: 'Medium Coverage',
    subText: '6 months Rent Coverage, 1 month Deposit Coverage',
    value: ScreeningResultsTypes.ApprovedWithConditions,
  },
  {
    id: 'max',
    text: 'Max Coverage',
    subText: '12 months Rent Coverage, 1 month Deposit Coverage',
    value: ScreeningResultsTypes.Denied,
  },
];

export const staticInstitutionalScreeningResultsOptions: ScreeningResultsOption[] = [
  {
    id: 'approved',
    text: 'Approved',
    value: ScreeningResultsTypes.Approved,
    tooltip: (
      <Typography color="white" component={'span'} variant={'body2'}>
        Renters who qualify for a lease and would like to replace their security deposit.
      </Typography>
    ),
  },
  {
    id: 'conditional',
    text: 'Approved with Conditions',
    value: ScreeningResultsTypes.ApprovedWithConditions,
    tooltip: (
      <Typography color="white" component={'span'} variant={'body2'}>
        Renters who are replacing a larger security deposit, or need TheGuarantors uniform homes to
        help them qualify for the lease.
      </Typography>
    ),
  },
  {
    id: 'denied',
    text: 'Denied',
    value: ScreeningResultsTypes.Denied,
    tooltip: (
      <Typography color="white" component={'span'} variant={'body2'}>
        Renters who need TheGuarantors to help them qualify for the lease.
      </Typography>
    ),
  },
];
